import { graphql } from 'react-relay';

export const fundsTableFragment = graphql`
    fragment FundsTable_table on FundsTable {
        ...FundsTableHeader_header
        entries( first: 1000) {
            edges {
                node {
                    id
                    fundsname
                    category
                    distribution
                    currency
                    country
                    traits
                    largeinvestmentfonds
                    tranches(first: 1000) {
                        edges {
                            node {
                                url
                                currency
                                distribution
                                id
                                isin
                                institutional
                                salesadmission
                            }
                        }
                    }
                    ...Fund_fund

                }
            }
        }
        detailfilter {
            selectioninfo {
                resultTextSingular
                resultTextPlural
            }
            ...DetailFilter_detailFilter
        }
        livefilter {
            ...LiveFilter_liveFilter
        }
        filterbuttontext
        filterbuttontextexpanded
        noResultsMessage
    }
`;
